import {enableProdMode, importProvidersFrom} from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { set } from "lodash-es";
import { bootstrapApplication } from "@angular/platform-browser";
import {BsDropdownModule} from "ngx-bootstrap/dropdown";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import { HttpClientModule } from "@angular/common/http";
import { provideRouter } from "@angular/router";
import { PREVIEW_ROUTES } from "@wms/app/app.routes";
import { PreviewAppComponent } from "./preview/preview-app/preview-app.component";
import { ToastrModule } from "ngx-toastr";
import { SsoCallbackAppComponent } from "./sso-callback-app/sso-callback-app.component";

if (environment.production) {
  enableProdMode();
}

const isPreview = window.location.href.includes('preview?project-id');
const isSSOCallback = window.location.href.includes('sso-callback');

set(environment, 'PREVIEW', isPreview);
if (isPreview) {
  bootstrapApplication(PreviewAppComponent, {
    providers: [
      importProvidersFrom(BsDropdownModule.forRoot()),
      importProvidersFrom(ToastrModule.forRoot()),
      importProvidersFrom(BrowserAnimationsModule),
      importProvidersFrom(HttpClientModule),
      provideRouter(PREVIEW_ROUTES)
    ]
  });
} else if (isSSOCallback) {
  bootstrapApplication(SsoCallbackAppComponent, {
    providers: [
      importProvidersFrom(BrowserAnimationsModule),
    ]
  });
} else {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}
